import http from '@/http/aisea/axios'
import { MULTIPART } from "@/config/";
const resource = "/port_master/enterprises/ports";

export default {
  download(portId, date) {
    return http.get(`${resource}/${portId}/tasks/voucher/${date}`, { responseType : 'blob' });
  },
};
